export default {
    DEFAULT: {
        value: 'DEFAULT',
        transKey: 'DROPDOWN.DEFAULT',
    },
    DATE_ENTRY_DESC: {
        value: 'DATE_ENTRY_DESC',
        transKey: 'DROPDOWN.DATE_ENTRY_DESC',
    },
    ODOMETER_ASC: {
        value: 'ODOMETER_ASC',
        transKey: 'DROPDOWN.ODOMETER_ASC',
    },
    ODOMETER_DESC: {
        value: 'ODOMETER_DESC',
        transKey: 'DROPDOWN.ODOMETER_DESC',
    },
    PRICE_ASC: {
        value: 'PRICE_ASC',
        transKey: 'DROPDOWN.PRICE_ASC',
    },
    PRICE_DESC: {
        value: 'PRICE_DESC',
        transKey: 'DROPDOWN.PRICE_DESC',
    },
    YEAR_ASC: {
        value: 'YEAR_ASC',
        transKey: 'DROPDOWN.YEAR_ASC',
    },
    YEAR_DESC: {
        value: 'YEAR_DESC',
        transKey: 'DROPDOWN.YEAR_DESC',
    },
};



// WEBPACK FOOTER //
// ./client/src/constants/sortings.js